import { render, staticRenderFns } from "./infoDetail.vue?vue&type=template&id=099f1d34&scoped=true&"
import script from "./infoDetail.vue?vue&type=script&lang=js&"
export * from "./infoDetail.vue?vue&type=script&lang=js&"
import style0 from "./infoDetail.vue?vue&type=style&index=0&id=099f1d34&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f1d34",
  null
  
)

export default component.exports